// @ts-nocheck
import swal from "sweetalert";
import { InitPage } from "../index";

class EOSWebhookLogs {
  constructor() {
    $('document').ready(function () {
      $('.webhook-info').on('click', function (e) {
        $('#webhook-body').html(e.currentTarget.dataset.body);
        $('#webhook-info').modal('show');
      });

      $('.webhook-retry-selected').on('click', function () {
        const ids = $.map($("input[name='webhook_log']:checked"), (content) => content.value);
        if (ids.length === 0) return;

        swal({
          title: 'Retry All Failed Items',
          text: 'Are you sure you want to continue retrying all failed items?',
          icon: 'warning',
          closeOnClickOutside: false,
          className: "sn-m-modal",
          buttons: {
            cancel: { text: "No", value: null, visible: true, className: "sn-btn sn-btn-sm sn-btn-silver", closeModal: true },
            confirm: { text: "Yes", value: true, visible: true, className: "sn-btn sn-btn-sm sn-btn-red", closeModal: true }
          },
          dangerMode: true,
        }).then((response) => {
          if (response) {
            $.ajax({
              type: 'POST',
              url: `${location.pathname}/retry_bulk`,
              data: { ids },
              success: function () {
                window.location.reload();
              }
            });
          }
        });
      });
    });
  }
}

export function LoadPage() {
  InitPage("webhook_logs", () => {
    new EOSWebhookLogs();
  });
}
